import { composeReducers } from 'common/util/composeReducers';
import { ACTIONS } from 'workflow/actions/inbox';


export function loadMyTasks(state, action) {
    if (!action || action.type !== ACTIONS.LOAD_MY_TASKS) {
        return state;
    }
    const myTasks = action.payload;

    return {
        ...state,
        myTasks: {
            tasks: myTasks,
            loading: false
        }
    };
}

export function loadMySignatureRequests(state, action){
    if (!action || action.type !== ACTIONS.LOAD_MY_SIGNATURE_REQUESTS) {
        return state;
    }
    const mySignatureRequests = action.payload;

    return {
        ...state,
        mySignatureRequests: {
            signatureRequests: mySignatureRequests,
            loading: false,
        }
    };
}

export function loadingInbox(state, action) {
    if(!action || action.type !== ACTIONS.LOADING_INBOX) {
        return state;
    }

    return {
        ...state,
        myTasks: {
            ...state.myTasks,
            loading: true
        }
    };
}

export default composeReducers(
    loadMyTasks,
    loadingInbox,
    loadMySignatureRequests,
);
